import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "./nav";
import { L } from "@/i18n";

export const NavLinks = ({ collapsed = false, onNavigate, prefix = "sidebar" }) => (
  <nav className="flex flex-col gap-1">
    {NAV_ITEMS.map(({ to, label, pt, icon: Icon, id }) => (
      <NavLink
        key={id}
        to={to}
        end={to === "/"}
        onClick={onNavigate}
        title={collapsed ? L(label, pt) : undefined}
        data-testid={`${prefix}-nav-${id}`}
        className={({ isActive }) =>
          `group relative flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors duration-200 ${
            collapsed ? "justify-center" : ""
          } ${
            isActive
              ? "bg-amber-500/10 text-amber-400"
              : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/60"
          }`
        }
      >
        {({ isActive }) => (
          <>
            {isActive && <span className="absolute left-0 top-2 bottom-2 w-0.5 rounded-full bg-amber-500" />}
            <Icon className="h-[18px] w-[18px] shrink-0" />
            {!collapsed && <span className="truncate">{L(label, pt)}</span>}
          </>
        )}
      </NavLink>
    ))}
  </nav>
);
